/**
 * Created with IntelliJ IDEA.
 * User: abahlk
 * Date: 12.07.13
 * Time: 11:22
 * To change this template use File | Settings | File Templates.
 */

import { ExternalLoggingConstants } from "../ExternalLoggingConstants";
import { AbstractLogObject } from "../logObjects/AbstractLogObject";
import { BasicLogObjectFactory } from "./BasicLogObjectFactory";

export class IOErrorLOFactory extends BasicLogObjectFactory {
    public static GENERAL_LOADER_IO_ERROR: number = 3001;
    public static GENERAL_TRACKING_IO_ERROR: number = 3002;
    public static GENERAL_LOADER_INVALID_DATA_ERROR: number = 3003;

    private static IO_ERROR: number = 3;

    private _operationText: string;
    private _url: string;

    constructor(subErrorId: number, operationText: string, url: string) {
        super();

        this._subErrorId = subErrorId;
        this._operationText = operationText;
        this._url = url;
    }

    public create(): AbstractLogObject {
        // Build the commonData
        let lo: AbstractLogObject = super.create();

        // Update with customData
        lo.logData.set(ExternalLoggingConstants.PARAM_LOG_EVENT_ID, IOErrorLOFactory.IO_ERROR.toString());

        lo.logData.set(ExternalLoggingConstants.PARAM_ERROR_EVENT_OPERATION_TEXT, this._operationText);
        lo.logData.set(ExternalLoggingConstants.PARAM_URL, this._url);

        return lo;
    }
}
